import { useState } from "react";
import "react-datepicker/dist/react-datepicker.css";
import { Button, Col, Input, Label, Row } from "reactstrap";

import { GetLanguageString } from "../../../helper/Components";
import SelectUnitForEventReport from "./SelectUnitForEventReport";

const status = [
  { value: null, label: "notifications_all" },
  { value: 0, label: "events_participants_attendance_absent" },
  {
    value: 1,
    label: "events_participants_attendance_present",
    checked: false,
  },
  { value: 2, label: "events_participants_attendance_leave" },
];

const SearchEventAttendeesList = ({
  searchEventParticipants,
  setSearchEventParticipants,
  setSearchButton,
}) => {
  const [initialUnitId] = useState(() => searchEventParticipants.unitId);

  const [values, setValues] = useState(searchEventParticipants);

  const handleSearchAttendanceStatus = (s) => {
    setValues({
      ...values,
      attendanceStatus: s,
    });
  };

  const handleSearch = () => {
    setSearchEventParticipants({
      ...values,
      unitId: values.unit.value,
    });
    setSearchButton(true);
  };

  return (
    <div className="ibox-content">
      <SelectUnitForEventReport
        unitId={initialUnitId}
        setValues={setValues}
        values={values}
      />
      <br></br>
      <Row style={{ marginLeft: "20px", marginTop: "5px" }}>
        {status.map((item, index) => {
          return (
            <Col md="1">
              <Label
                className="form-check form-check-inline"
                for={"statusRufqaCheck" + item.value}
              >
                <Input
                  id={"statusRufqaCheck" + item.value}
                  type="radio"
                  checked={item.value === values.attendanceStatus}
                  value={values.attendanceStatus}
                  name={"statusRafiq" + item.value}
                  onChange={() => handleSearchAttendanceStatus(item.value)}
                  className="form-check-input"
                />
                {<GetLanguageString props={item.label} />}
              </Label>
            </Col>
          );
        })}
      </Row>
      <Row>
        <Col md="12" className="text-center m-t-sm">
          <Button color="primary" type="submit" onClick={handleSearch}>
            {<GetLanguageString props="funds_submit" />}
          </Button>
        </Col>
      </Row>
    </div>
  );
};

export default SearchEventAttendeesList;
